import {Button, Card, Form, Input, message, Typography} from "antd";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import React, {useState} from "react";
import axios from 'axios'
import {useAuth} from "../auth/AuthProvider";

const {Title} = Typography

const Login = () => {
    const {login} = useAuth();
    const [isLoading, setIsLoading] = useState(false)

    const onFinish = (values: any) => {
        setIsLoading(true)
        axios.post('api/v1/login', values).then(({data}) => {
            setIsLoading(false)
            login(data.user);
            localStorage.setItem('key', `BEARER ${data.token}`)
        }).catch(() => {
            setIsLoading(false)
            message.error('Username or Password is invalid')
        })
    };

    return (
        <div
            style={{
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f0f2f5",
            }}
        >
            <Card style={{width: 360, borderRadius: 12}}>
                <Title level={3} style={{textAlign: "center"}}>
                    Login
                </Title>

                <Form onFinish={onFinish}>
                    <Form.Item name="login" rules={[{required: true}]}>
                        <Input prefix={<UserOutlined/>} placeholder="Type your login"/>
                    </Form.Item>

                    <Form.Item name="password" rules={[{required: true}]}>
                        <Input.Password prefix={<LockOutlined/>} placeholder="Type your password"/>
                    </Form.Item>

                    <Button loading={isLoading} type="primary" htmlType="submit" block>
                        Login
                    </Button>
                </Form>
            </Card>
        </div>
    );
};

export default Login;